<template>
  <div id="updateAvailable" hidden class="bg-red-500 text-center cursor-pointer" @click="refreshApplication">Er is een update beschikbaar. Klik hier om de applicatie te verversen</div>
  <div class="flex h-full" :class="{ 'touchscreen-mode': activeUser?.settings?.touchScreen == true }">
    <AppDebugInfo/>
    <AppGlobalSearch
      v-if="showGlobalSearch"
      @close="() => (showGlobalSearch = false)"
      @open-q-bot="() => {showQBotSearch = true; showGlobalSearch = false}"
    />
    <AppQBotSearch
      v-if="showQBotSearch"
      @close="() => (showQBotSearch = false)"
    />
    <template v-if="isLoading">
      <AppIcon
        class="text-black m-auto"
        size="5x"
        icon="spinner"
        spin-pulse
      />
    </template>

    <div class="flex flex-row gap-1 w-full overflow-hidden" v-else-if="authenticated && activeUser && activeCompany">
      <Sidebar/>
      <div class="flex flex-col w-full my-1 mr-1">
        <WindowTabBar/>
        <div
          class="h-full w-full flex grow border-2 border-primary rounded rounded-tl-none overflow-y-auto"
        >
          <RouterView v-slot="{ Component, route }">
            <KeepAlive :max="30">
              <Component
                :is="Component"
                :key="route.fullPath"
                ref="activeTabComponent"
              />
            </KeepAlive>
          </RouterView>
        </div>
      </div>
    </div>
    <template v-else>
      <SecurityLogin/>
    </template>
    <Toaster
      rich-colors
      close-button
    />
  </div>
</template>

<script setup lang="ts">
import { Toaster } from "vue-sonner";
import { currentSession } from "@q-food/q-food";
import { RouterView } from "vue-router";
import SecurityLogin from "~/views/security.login.vue";
import { useAppStore } from "~stores/App";
import { useUserStore } from "~stores/User";
import { useAppTabs } from "./stores/useAppTabs";

const { appTitle, showGlobalSearch, showQBotSearch } = storeToRefs(useAppStore());
const { authenticated, activeUser, activeCompany } = storeToRefs(useUserStore());

const { closeCurrentTab } = useAppTabs();

/**
 * Register in-app keyboard shortcuts
 */
usePredefinedKeyStroke("window.closeTab", closeCurrentTab);
usePredefinedKeyStroke("window.toggleGlobalSearch", () => {
	showGlobalSearch.value = true;
});

// Load the current session and then refresh the user info and sidebar
const isLoading = ref(true);
currentSession()
	.then(async () => {
		await useAppStore().refreshApp();
	})
	.catch((response) => {
		switch (response.status) {
			case 403:
				// no need to show message
				break;
			default:
				throw Error(response);
		}
	})
	.finally(() => {
		isLoading.value = false;
	});

function refreshApplication() {
	window.location.reload();
}

useTitle(appTitle);
</script>

<style scoped></style>
